import { motion } from "framer-motion";

const photos = [
  { src: "/photos/IMG_9505.jpeg", alt: "Coach Abrie laughing with a toddler face to face in the pool" },
  { src: "/photos/IMG_9500.jpeg", alt: "Young girl floating happily on her back" },
  { src: "/photos/IMG_9514.jpeg", alt: "Boy wearing rainbow goggles smiling with his swim teacher" },
  { src: "/photos/IMG_9507.jpeg", alt: "Toddler in a pink swimsuit playing with her instructor" },
  { src: "/photos/IMG_9512.jpeg", alt: "Swimmer practicing breath control with instructor guidance" },
  { src: "/photos/IMG_9503.jpeg", alt: "Instructor gently supporting a toddler floating on her back" },
  { src: "/photos/IMG_9506.jpeg", alt: "Girl practicing at the pool edge with her instructor" },
  { src: "/photos/IMG_9516.jpeg", alt: "Kids enjoying water games with pool toys during a lesson" },
  { src: "/photos/IMG_9510.jpeg", alt: "Instructor encouraging a boy with goggles to reach in the water" },
  { src: "/photos/IMG_9518.jpeg", alt: "Lesson in progress at the Four Seasons community pool" },
  { src: "/photos/IMG_9508.jpeg", alt: "Instructor encouraging two children with a rubber duck toy" },
  { src: "/photos/IMG_9513.jpeg", alt: "Toddler laughing while kicking in the water with her instructor" },
  { src: "/photos/IMG_9515.jpeg", alt: "Coach Abrie gently guiding a young swimmer with a kickboard" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="scroll-mt-24 bg-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-8 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#c97049]">Real swimmers · Real smiles</p>
          <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold text-[#00334a]">
            This is what swim day looks like at your pool
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#00334a]/70 leading-relaxed">
            Every photo below is a real Little Splash lesson — no stock images, no models.
            Just neighborhood kids becoming confident swimmers.
          </p>
        </motion.div>
        <div className="mt-12 columns-2 sm:columns-3 gap-4 [column-fill:balance]">
          {photos.map((p, i) => (
            <motion.img
              key={p.src}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              src={p.src}
              alt={p.alt}
              loading="lazy"
              data-testid={`gallery-photo-${i + 1}`}
              className="gallery-img mb-4 w-full rounded-2xl break-inside-avoid shadow-md"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
